<template>
  <div>
    <custom-actions :panel="false">
      <template #header>
        <el-button @click="$router.push('/system/menu/add')" type="primary">新增菜单</el-button>
      </template>
    </custom-actions>

    <el-card shadow="never" class="mt10">
      <el-table size="mini" stripe border v-loading="loading" :data="tableData" row-key="menuId" :tree-props="{children: 'childNode'}">
        <el-table-column label="菜单名称" min-width="100" prop="menuName"></el-table-column>
        <el-table-column label="菜单编码" prop="menuCode"></el-table-column>
        <el-table-column label="菜单地址" prop="url"></el-table-column>
        <el-table-column label="菜单图标" prop="iconPath"></el-table-column>
        <el-table-column label="菜单状态" prop="status">
          <template v-slot="{ row }">
            <el-tag size="mini" type="success" v-if="row.status === '1'">启用</el-tag>
            <el-tag size="mini" type="danger" v-else-if="row.status === '2'">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="按钮权限" min-width="120" prop="">
          <template v-slot="{ row }">
            <div v-if="row.button && row.button.length">
              <el-tag size="mini" type="primary" v-for="(item, index) of row.button" :key="index">
                {{ item.butName  }}({{ item.butCode }})
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="orderNum"></el-table-column>
        <el-table-column label="操作" prop="">
          <template v-slot="{ row }">
            <el-button type="text" @click="$router.push('/system/menu/edit?id=' + row.menuId)">编辑</el-button>
            <el-button type="text" @click="changeStatus(row.menuId,row.status)">{{row.status === '1'?'禁用':row.status === '2'?'启用':''}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'MenuManage',
  data () {
    return {
      loading: false,
      tableData: []
    }
  },
  created () {
    this.loadData2()
  },
  methods: {
    loadData2 () {
      this.$axios.get(this.$apis.system.selectIparkMenuTreeList, {
        params: {
          menuType: '1'
        }
      }).then(res => {
        this.tableData = res || []
      })
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.system.selectSysMenuByList).then(res => {
        this.tableData = res.list
      }).finally(() => {
        this.loading = false
      })
    },
    changeStatus (menuId, status) {
      this.loading = true
      this.$axios.post(this.$apis.system.disableSysMenu, { menuId }).then(res => {
        // const text = status === 1 ? '禁用成功' : status === 2 ? '启用成功' : ''
        // this.$message.success(text)
        this.loadData2()
      }).finally(() => {
        this.loading = false
      })
    },
    handleNodeClick () {}
  }
}
</script>

<style scoped lang='scss'>

</style>
